// The one place that spells an alert's address. Every sitemap, feed, canonical
// tag and share link builds from here, so a slug change shows up everywhere at
// once. API slugs are [a-z0-9-], so encodeURIComponent is a no-op today and a
// guard for tomorrow.
export const alertPath = (slug) =>
    slug ? `/news-alerts/${encodeURIComponent(slug)}` : null;

export const alertUrl = (slug, host = process.env.HOST) =>
    slug ? `${host}${alertPath(slug)}` : null;
